export function canViewLoginActivity(user: any): boolean {
  const role = Number(user && user.role);
  const organizationRole = Number(user && user.organization && user.organization.role);
  return (role === 0 || role === 1) && organizationRole === role;
}
